import {useState} from 'react';
import {
  HeroP2,
  Input,
  MintButton,
  IncrementButton,
  DecrementButton
} from "./MintInputsElements";



const MintInputs = ({maxMintAmount = 5, handleMint}) => {
  const [mintAmount, setMintAmount] = useState(1);

  const onMint = () => {
    handleMint(mintAmount);
  }

  const handleDecrement = () => {
    if (mintAmount <= 1) return;
    setMintAmount(mintAmount - 1);
  };

  const handleIncrement = () => {
    if (mintAmount >= maxMintAmount) return;
    setMintAmount(mintAmount + 1);
  };

  return (
    <>
      <HeroP2>Whitelist Mint</HeroP2>
      <HeroP2><DecrementButton onClick={ handleDecrement }>-</DecrementButton><Input readOnly value= {mintAmount} /><IncrementButton onClick={ handleIncrement }>+</IncrementButton><MintButton onClick={ onMint }>Mint</MintButton></HeroP2>
    </>
  );
};

export default MintInputs;
